export default __webpack_public_path__ + "static/media/Project_2.3a7d075a.png";